import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { jsonGet, jsonPut } from '../api/jsonRequest';
import { queryKeys } from '../query/queryKeys';
import { usePollQuery } from '../query/usePollQuery';

export function useSAConfig({ enabled = true, pauseRefetch = false } = {}) {
    return usePollQuery({
        queryKey: queryKeys.saConfig.admin(),
        url: '/api/Account/FetchSAConf',
        enabled,
        pauseRefetch,
    });
}

export function useSAPublicConfig({ enabled = true } = {}) {
    return useQuery({
        queryKey: queryKeys.saConfig.public(),
        queryFn: () => jsonGet('/api/Account/FetchSAPublicConf'),
        enabled,
        staleTime: 5 * 60 * 1000,
    });
}

export function useEditSAConfig() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload) => {
            const res = await jsonPut('/api/Account/UpdateSAConfig', payload);
            if (res.status !== 200) {
                throw new Error('SA config update failed');
            }
            return res.data;
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: queryKeys.saConfig.all() });
        },
    });
}
